<template>
  <div class="gl-cart">
    <vue-progress-bar/>

    <div class="items">
      <template v-for="(item, index) in cart">
        <div class="box">
          <article class="media">
            <figure v-if="imageUrl(item.product.data)" class="media-left">
              <p class="image is-48x48">
                <a :href="item.product.data.url"><img :src="imageUrl(item.product.data)" alt=""></a>
              </p>
            </figure>

            <div class="media-content">
              <div class="content">
                <div class="product-info">
                  <div class="product-title">
                    <a :href="item.product.data.url"
                       class="title is-5">{{item.product.data.name}}</a>
                  </div>
                  <small>{{item.product.data.short_description}}</small>
                </div>

                <div class="params">
                  <p><b>Размер:</b> {{item.name}}</p>
                  <p>
                    <b>Цена:</b>
                    <span title="Цена за единицу">{{numeral(item.price).format('0.00 $')}}</span>
                    <span class="op">x</span>
                    <span title="Количество">{{item.quantity}}</span>
                    <span class="op">=</span>
                    <span title="Сумма">{{numeral(item.total).format('0.00 $')}}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="media-right">
              <button
                @click="handleRemove(index)"
                :class="[{'is-loading': loading}, 'is-hidden-mobile', 'button', 'is-small','is-danger']"
                title="Удалить">
                <span class="icon">
                 <icon name="remove" scale="1" class="el-icon-fa"></icon>
                </span>
                <span>Удалить</span>
              </button>

              <button
                @click="handleRemove(index)"
                :class="[{'is-loading': loading}, 'is-hidden-desktop', 'button', 'is-small','is-danger']"
                class="is-hidden-desktop button is-small is-danger"
                title="Удалить">
                <span class="icon">
                 <icon name="remove" scale="1" class="el-icon-fa"></icon>
                </span>
              </button>
            </div>
          </article>
        </div>
      </template>
    </div>

    <div class="row">
      <b>Товаров {{numeral(totalCount).format('0,0')}} на сумму {{numeral(totalPrice).format('0.00 $')}}</b>
    </div>

    <div v-if="totalCount > 0" class="row">
      <button
        @click="handleMoveToOrder"
        class="button is-primary">
        <span class="icon">
          <icon name="check" scale="1" class="el-icon-fa"></icon>
        </span>
        <span>Перейти к оформлению</span>
      </button>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters, mapState, mapActions } from 'vuex'
  import * as types from 'glonass/shop/site/store/mutation-types'
  import { numeral } from 'glonass/core/global'

  /**
   * Список ценовых предложений с кнопкой добавления в корзину.
   */
  export default {
    name: 'cart',

    data () {
      return {
        numeral
      }
    },

    watch: {
      loading () {
        this.loading ? this.$Progress.start() : this.$Progress.finish()
      }
    },

    methods: {
      ...mapActions('shop', [
        'removeFromCart'
      ]),

      handleMoveToOrder () {
        location.assign('/shop/order')
      },

      handleRemove (index) {
        if (!confirm('Удалить выбранный товар из корзины?')) {
          return
        }

        let item = this.cart[index]
        this.removeFromCart(item.rowId)
      },

      imageUrl (product) {
        return _.get(product, 'media.data.images[0].medium')
      }
    },

    computed: {
      ...mapState('shop', {
        cart: state => state.cart,
        loading: state => !!state.loading[types.REMOVE_FROM_CART],
        success: state => state.success[types.REMOVE_FROM_CART],
        errors: state => state.errors[types.REMOVE_FROM_CART]
      }),
      ...mapGetters('shop', [
        'totalCount',
        'totalPrice'
      ])
    }
  }
</script>

<style scoped lang="scss">
  .row {
    margin-bottom: 0.5rem;
  }

  .items {
    margin-bottom: 1rem;

    .product-info {
      margin-bottom: .5rem;

      .title {
        margin-bottom: .25rem;
      }
    }

    .params p {
      margin-bottom: .5rem;
    }
  }

  .total-row {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// Widget.vue?05a573e7